/* EASTEAM — PDP Before/After slider (Drop 05 2.0)
   Appends one extra gallery slide (and its thumbnail) to the PDP gallery:
   a draggable before/after of the same model in the nude base plate vs the piece.
   Additive by design — sections/easteam-pdp.liquid is untouched.
   Config comes from snippets/ea-ba-slider.liquid as window.EA_BA.
   MIRRORS the PDP gallery markup: .gallery > .slides > .slide  and  .thumbs > .thumb[data-ea-thumb].
   If that markup changes in easteam-pdp.liquid, change it here too. */
(function () {
  'use strict';
  var CFG = window.EA_BA;
  if (!CFG || !CFG.before || !CFG.after) return;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  function buildSlider() {
    var box = el('div', 'ea-ba');
    box.setAttribute('tabindex', '0');
    box.setAttribute('role', 'slider');
    box.setAttribute('aria-label', 'Before and after: ' + (CFG.title || 'this piece'));
    box.setAttribute('aria-valuemin', '0');
    box.setAttribute('aria-valuemax', '100');
    box.setAttribute('aria-valuenow', '50');

    var after = el('img');
    after.src = CFG.after;
    after.alt = (CFG.title || '') + ' worn';
    after.loading = 'lazy';
    after.draggable = false;

    var beforeWrap = el('div', 'ea-ba-before');
    var before = el('img');
    before.src = CFG.before;
    before.alt = 'Without the piece';
    before.loading = 'lazy';
    before.draggable = false;
    beforeWrap.appendChild(before);

    var line = el('div', 'ea-ba-line');
    line.appendChild(el('div', 'ea-ba-knob',
      '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" focusable="false">' +
      '<path d="M9 5v14M15 5v14" stroke="#0A0807" stroke-width="2" stroke-linecap="round" fill="none"/></svg>'));

    box.appendChild(after);
    box.appendChild(beforeWrap);
    box.appendChild(el('span', 'ea-ba-tag ea-ba-tag-b', CFG.labelBefore || 'Before'));
    box.appendChild(el('span', 'ea-ba-tag ea-ba-tag-a', CFG.labelAfter || 'After'));
    box.appendChild(line);
    box.appendChild(el('div', 'ea-ba-hint', CFG.hint || 'Drag to reveal'));

    var dragging = false;

    function set(p) {
      p = Math.max(0, Math.min(100, p));
      beforeWrap.style.width = p + '%';
      line.style.left = p + '%';
      before.style.width = (p > 0.5 ? (10000 / p) : 20000) + '%';
      box.setAttribute('aria-valuenow', String(Math.round(p)));
    }
    function fromEvent(e) {
      var r = box.getBoundingClientRect();
      if (!r.width) return;
      set(((e.clientX - r.left) / r.width) * 100);
    }
    box.addEventListener('pointerdown', function (e) {
      dragging = true;
      box.classList.add('is-touched');
      try { box.setPointerCapture(e.pointerId); } catch (err) {}
      fromEvent(e);
      e.preventDefault();
      e.stopPropagation();
    });
    box.addEventListener('pointermove', function (e) { if (dragging) { fromEvent(e); e.preventDefault(); } });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
      box.addEventListener(t, function () { dragging = false; });
    });
    /* the gallery slide is .zoomable on normal slides; this one is not, but stop any
       stray click from bubbling into the theme's lightbox handlers anyway */
    box.addEventListener('click', function (e) { e.stopPropagation(); });
    box.addEventListener('keydown', function (e) {
      var cur = parseFloat(box.getAttribute('aria-valuenow')) || 50;
      if (e.key === 'ArrowLeft') { set(cur - 4); box.classList.add('is-touched'); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(cur + 4); box.classList.add('is-touched'); e.preventDefault(); }
    });
    set(50);
    return box;
  }

  function attach(gallery) {
    if (gallery.querySelector('.ea-ba')) return true;
    var slides = gallery.querySelector('.slides');
    if (!slides || !slides.children.length) return false;

    var model = slides.children[slides.children.length - 1];
    var slide = el('div', 'slide ea-ba-slide');
    /* copy inline sizing the theme may have put on a slide, but never .zoomable */
    if (model.getAttribute('style')) slide.setAttribute('style', model.getAttribute('style'));
    slide.appendChild(buildSlider());
    slides.appendChild(slide);

    var thumbs = gallery.parentElement && gallery.parentElement.querySelector('.thumbs');
    if (!thumbs) thumbs = document.querySelector('.thumbs');
    var myThumb = null;
    if (thumbs && thumbs.children.length) {
      var idx = slides.children.length - 1;
      myThumb = el('button', 'thumb ea-ba-thumb');
      myThumb.type = 'button';
      myThumb.dataset.eaThumb = String(idx);
      myThumb.setAttribute('aria-label', 'Before and after');
      var timg = el('img');
      timg.src = CFG.after;
      timg.alt = '';
      timg.loading = 'lazy';
      myThumb.appendChild(timg);
      myThumb.appendChild(el('span', 'ea-ba-thumb-badge', CFG.thumbBadge || 'FIT'));
      thumbs.appendChild(myThumb);
      myThumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide();
      });
    }

    /* scroll-snap plus smooth behaviour is unreliable on this carousel, so the
       smooth attempt is followed by a hard assignment if it did not land */
    function goToSlide() {
      var target = slide.offsetLeft - slides.offsetLeft;
      try {
        slides.scrollTo({ left: target, behavior: 'smooth' });
      } catch (err) {
        slides.scrollLeft = target;
      }
      setTimeout(function () {
        if (Math.abs(slides.scrollLeft - target) > 4) slides.scrollLeft = target;
        syncActive();
      }, 450);
    }

    /* keep the active-thumb state in sync: the section's own observer was built
       before this slide existed, so it never sees it */
    function syncActive() {
      if (!myThumb) return;
      var r = slides.getBoundingClientRect();
      var s = slide.getBoundingClientRect();
      var mid = r.left + r.width / 2;
      var mine = s.left <= mid && s.right >= mid;
      if (mine) {
        Array.prototype.forEach.call(thumbs.children, function (t) { t.classList.remove('on'); });
        myThumb.classList.add('on');
      } else {
        myThumb.classList.remove('on');
      }
    }
    var tick;
    slides.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(syncActive, 80);
    }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(tick); tick = setTimeout(syncActive, 120); });
    syncActive();
    return true;
  }

  function run() {
    var done = false;
    document.querySelectorAll('.ea-pdp .gallery').forEach(function (g) { if (attach(g)) done = true; });
    return done;
  }

  function boot() {
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (run() || tries > 40) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
